






















































































































































































import { Component, Vue } from "vue-property-decorator";
import { authGuard } from "../auth/authGuard";
import { Subscription } from "@/interfaces/subscription";
import Product from "@/interfaces/product";
import { User } from "@/interfaces/user";
import { FileService } from "../services/fileService";
import { AuthService } from "../services/authService";
import { SubscriptionService } from "../services/subscriptionService";
import PaypalCheckout from "@/components/paypalCheckout.vue";
import { ProductService } from "../services/productService";

@Component({
    components: { PaypalCheckout },
    beforeRouteEnter: authGuard,
})
export default class Profile extends Vue {
    public dialogDelete: boolean = false;
    public itemToDelete: string = "";
    public product: Product | null = null;
    public loadingReady: boolean = false;

    public token: string = "";

    public get userLikeChatWidgetId(): string {
        return this.$store.state.user?.userLikeChatWidgetId || "";
    }
    public set userLikeChatWidgetId(newValue: string) {
        if (this.$store.state.user) {
            this.$store.state.user.userLikeChatWidgetId = newValue;
        }
    }

    public async mounted() {
        this.token = await this.$auth.getTokenSilently();
        ProductService.getProduct("profile").then(response => {
            this.product = response;
            this.loadingReady = true;
        });
    }

    public get isPremium(): boolean {
        if (this.$store.state.user) {
            const activeSubs = this.$store.state.user.subscriptions.filter(
                (s: Subscription) => s.status == "active"
            );

            if (activeSubs.length != 0) {
                return true;
            } else return false;
        } else return false;
    }
    public get storeUser(): User | null {
        return this.$store.state.user;
    }

    public get displayname() {
        return this.storeUser?.displayname || "";
    }

    public set displayname(newName: string) {
        if (this.storeUser) {
            this.storeUser.displayname = newName;
        }
    }

    public get tableHeaders() {
        return [
            { text: this.$t("profile.subscription"), value: "id" },
            { text: this.$t("profile.validTo"), value: "validDate" },
            { text: "Status", value: "status" },
            { text: this.$t("profile.endSubscription"), value: "action" },
            { text: "", value: "data-table-expand" },
        ];
    }
    public get tableData(): Subscription[] {
        if (this.storeUser && this.storeUser.subscriptions) {
            return this.storeUser.subscriptions;
        } else return [];
    }
    public async getInvoice(id: string) {
        const file = await FileService.getInvoice(id, this.token);
        const fileURL = window.URL.createObjectURL(file);
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `${id}.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
    }

    public async updateUserLikeChatWidgetId() {
        const validation = await AuthService.validateUserlikeChatWidgetId(
            this.userLikeChatWidgetId
        );
        if (validation == 200) {
            await AuthService.updateUserlikeChat(
                this.userLikeChatWidgetId,
                this.token
            );
            this.$store.commit("showSnackbar", {
                text: this.$t("profile.userLikeChatUpdated"),
                color: "success",
            });
            return;
        }
        this.$store.commit("showSnackbar", {
            text: this.$t("profile.userLikeChatUpdatedError"),
            color: "error",
        });
        this.userLikeChatWidgetId = "";
    }

    public async updatDisplayname() {
        if (this.storeUser) {
            await AuthService.updateDisplayname(
                this.displayname,
                this.storeUser.id,
                this.token
            );
            this.$store.commit("showSnackbar", {
                text: this.$t("profile.displayNameUpdated"),
                color: "success",
            });
        }
    }

    public cancelSubscription(id: string) {
        this.itemToDelete = id;
        this.dialogDelete = true;
    }

    public closeDelete() {
        this.dialogDelete = false;
        this.itemToDelete = "";
    }
    public async deleteItemConfirm() {
        try {
            await SubscriptionService.cancelSubscription(
                this.itemToDelete,
                this.token
            );
        } catch {
            console.log("error deleting");
        }
        this.dialogDelete = false;
        this.itemToDelete = "";
        const user = await AuthService.getUser(this.token);
        this.$store.commit("setUser", { user });
    }

    public hasPermission() {
        if (this.$store.state.user?.permissions.includes("userlikechat")) {
            return true;
        }
        return false;
    }
}
